//#region src/utils/portalRoot.ts
var e = "uikit-root", t = () => {
	let t = document.getElementById(e), n = document.createElement("div");
	return n.setAttribute("id", e), t || document.body.appendChild(n);
};
//#endregion
export { e as PORTAL_ROOT_ID, t as getOrCreatePortalRoot };

//# sourceMappingURL=portalRoot.js.map